import { Admin } from "./admin.model";
import { AuthType } from "../models/enums/auth-type.enum";
import { UserBuilder } from "./user.builder";
import * as firebase from "firebase";
import { firestore } from "firebase-admin";
export class User {
  public id: string;
  public admin: Admin;
  public birthday: string; //MM/DD/YYYY
  public createdAt: Date;
  public credits: number;
  public customerId: string;
  public email: string;
  public lastLoggedIn: Date;
  public name: string;
  public phone: string;
  public image: string;
  public referredBy: string;
  public deletedAt: firestore.Timestamp;

  constructor(builder: UserBuilder) {
    this.id = builder.id ?? null;
    this.admin = new Admin(builder.admin);
    this.birthday = builder.birthday;
    this.createdAt = builder.createdAt.toDate();
    this.lastLoggedIn = builder.lastLoggedIn
      ? builder.lastLoggedIn.toDate()
      : null;
    this.name = builder.name;
    this.phone = builder.phone;
    this.image = builder.image;
    this.email = builder.email;
    this.referredBy = builder.referredBy;
  }

  get canEdit(): boolean {
    return (
      this.admin.type == AuthType.LineLeapAdmin ||
      this.admin.type == AuthType.VenueAdmin
    );
  }

  toJSON() {
    return {
      admin: this.admin.toJSON(),
      createdAt: firebase.firestore.Timestamp.fromDate(this.createdAt),
      email: this.email,
      lastLoggedIn:
        this.lastLoggedIn == null
          ? null
          : firebase.firestore.Timestamp.fromDate(this.lastLoggedIn),
      name: this.name,
      phone: this.phone
    };
  }

  get isAdmin(): boolean {
    return this.admin.type == AuthType.LineLeapAdmin;
  }

  get canAccess(): boolean {
    return (
      this.admin.type == AuthType.LineLeapAdmin ||
      this.admin.type == AuthType.VenueAdmin
    );
  }
}
